import { ChangeEvent } from "react";

type FileInputProps = {
  id: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  /** Navnet på den valgte fil. Uden værdi vises "Ingen fil valgt". */
  fileName?: string;
  accept?: string;
  required?: boolean;
  "aria-describedby"?: string;
};

/**
 * Fil-input med dansk tekst.
 *
 * Et native `<input type="file">` tegner selv sin knap og sin "ingen fil
 * valgt"-tekst på browserens/OS'ets sprog, og det kan ikke oversættes -- hverken
 * med attributter eller CSS. Derfor skjules inputtet visuelt, mens det bliver
 * fokuserbart og oplæst af skærmlæsere (se `_c-file-input.scss`, ikke
 * `display: none`), og en `<label htmlFor>` tegner den danske kontrol oven på
 * det. Fordi det er en rigtig label, åbner et klik filvælgeren uden JavaScript.
 *
 * Selve labelen er `aria-hidden`, fordi feltet allerede har en synlig label
 * ovenover; ellers ville skærmlæsere læse begge og navngive feltet
 * "Upload foto Vælg fil Ingen fil valgt". Skærmlæsere oplyser selv det valgte
 * filnavn ud fra inputtets værdi.
 */
export default function FileInput({
  id,
  onChange,
  fileName,
  accept,
  required,
  "aria-describedby": ariaDescribedBy,
}: FileInputProps) {
  return (
    <div className="c-file-input">
      <input
        id={id}
        type="file"
        className="c-file-input__input"
        accept={accept}
        required={required}
        aria-describedby={ariaDescribedBy}
        onChange={onChange}
      />
      <label className="c-file-input__control" htmlFor={id} aria-hidden="true">
        <span className="btn btn-outline btn-sm">Vælg fil</span>
        <span className={`c-file-input__name${fileName ? "" : " text-muted"}`}>
          {fileName || "Ingen fil valgt"}
        </span>
      </label>
    </div>
  );
}
